var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen bg-primary-dark",attrs:{"id":"app"}},[_c('a',{staticClass:"hidden",attrs:{"href":"/business-consumer"}}),_c('a',{staticClass:"hidden",attrs:{"href":"/about"}}),_c('Header',{attrs:{"isHeader":_vm.isHeader}}),_c('router-view',{on:{"header":function($event){_vm.isHeader = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }